import { render, staticRenderFns } from "./manMadeOrder.vue?vue&type=template&id=22be564f&scoped=true"
import script from "./manMadeOrder.vue?vue&type=script&lang=js"
export * from "./manMadeOrder.vue?vue&type=script&lang=js"
import style0 from "./manMadeOrder.vue?vue&type=style&index=0&id=22be564f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be564f",
  null
  
)

export default component.exports